// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__39ahz","Alt":"Button_Alt__1s45V"};